// The standings: constellations ranked by their step-3 score, the highest
// first; of two alike, the one spelled first ranks higher.
import type { StandingEntry } from '../types';

export function ranked(entries: readonly StandingEntry[]): StandingEntry[] {
  return [...entries].sort((a, b) => b.score - a.score || a.index - b.index);
}
